import React, { useState, useEffect, Fragment } from 'react';
import InsertText from '../data/insert-text-at-cursor';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    InputGroup,
    Badge,
    CardBody,
    Label
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Property_List,
    gAPI_Ingetration, pAPI_BookingEnginUrlIntegration
} from '../../../../../constants/APIs';
import TestIntegrationBookingUrl from './TestIntegrationBookingUrl';
import { ShowChart } from '@material-ui/icons';
import { date } from 'yup';
import Validation from '../../../../../components/Validation';
const MyTextbox = React.forwardRef(({ contents, onChange }, ref) => {
    let myContents = contents;

    return (
        <Input
            type="textarea"
            ref={ref}
            name="bookingUrl"
            onChange={onChange}
            placeholder="Booking Engine URL"
            value={myContents}
            rows={5}
        />
    );
});
const tokens = [
    { value: "{CHECK_IN}" },
    { value: "{CHECK_OUT}" },
    { value: "{NIGHTS}" },
    { value: "{ADULTS}" },
    { value: "{CHILDREN}" },
    { value: "{CHILDREN_AGE}" },
    { value: "{ROOM_TYPE}" },
    { value: "{PROMO_CODE}" },
    // { value: "{SOURCE}" },
    { value: "{LANGUAGE}" },
    { value: "{CURRENCY}" }
];


export default function BookingEngineUrlIntegration({ selectedProperty, integrationId, integrationData }) {
    const [todayDate, setTodateDate] = useState(moment());
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [isTestIntegration, setIsTestIntegration] = useState(false);
    const [isDate, setIsDate] = useState(false);
    const textbox = React.createRef();
    const [selectedTokens, setSelectedTokens] = useState([]);
    const [inputData, setInputData] = useState(integrationData);
    const [bookingEngineData, setBookingEngineData] = useState({
        propertyId: "",
        dateFormat: "YYYY-MM-DD",
        bookingUrl: "",
        urlDisabled: false
    });
    function generateRandomColor(index) {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
        ];
        return arr[Math.floor(Math.random() * arr.length)];
    }
    useEffect(() => {
        setBookingEngineData({ ...bookingEngineData, propertyId: selectedProperty[0].id });

        if (integrationData.bookingEngineUrls !== undefined &&
            integrationData.bookingEngineUrls !== null &&
            integrationData.bookingEngineUrls.length > 0) {
            let result = [];
            let tok = [];
            let isdate = false;
            selectedProperty.map(item => {
                result = integrationData.bookingEngineUrls.filter(elem => elem.propertyId === item.id);
            });
            if (result[0] !== undefined) {
                tokens.map((items) => {
                    if (result[0].bookingUrl.includes(items.value)) {
                        tok.push({
                            value: items.value
                        })
                    }
                });
                if (result[0].bookingUrl.includes("{CHECK_IN}") || result[0].bookingUrl.includes("{CHECK_OUT}")) {
                    isdate = true;
                }
                else {
                    isdate = false;
                }
                setBookingEngineData(result[0]);
            }
            else {
                setBookingEngineData({
                    propertyId: selectedProperty[0].id,
                    dateFormat: "YYYY-MM-DD",
                    bookingUrl: "",
                    urlDisabled: false
                });
            }
            setIsDate(isdate);
            setSelectedTokens(tok);
        }
    }, [selectedProperty]);
    const handleCheckChange = (e) => {
        if (e.target.type === "radio") {
            if (e.target.checked) {
                setInputData({ ...inputData, properties: [e.target.value] });
            }
            if (!e.target.checked) {
                setInputData({ ...inputData, properties: [] });
            }
        }
        else {
            setBookingEngineData({ ...bookingEngineData, urlDisabled: !e.target.checked });
        }
    };
    const handleNameChange = (e) => {
        setInputData({ ...inputData, name: e.target.value });
    }
    const handleDateChange = (e) => {
        setBookingEngineData({ ...bookingEngineData, dateFormat: e.target.value });
    }
    const handleChange = (evt) => {
        let s = evt.target.value;
        let tok = [];
        tokens.map((items) => {
            if (s.includes(items.value)) {
                tok.push({
                    value: items.value
                })
            }
        });
        if (s.includes("{CHECK_IN}") || s.includes("{CHECK_OUT}")) {
            setIsDate(true);
        }
        else {
            setIsDate(false);
        }
        setSelectedTokens(tok);
        setBookingEngineData({ ...bookingEngineData, bookingUrl: s });
    };

    const handleInsert = (name) => {
        var text = document.getElementsByName("bookingUrl");
        text[0].focus();
        InsertText(textbox.current, name);
    };

    const handleTestIntegration = () => {
        if (bookingEngineData.bookingUrl.includes("{CHECK_IN}") || bookingEngineData.bookingUrl.includes("{CHECK_OUT}")) {
            setIsDate(true);
        }
        else {
            setIsDate(false);
        }
        setIsTestIntegration(true);
    };
    const handleSave = () => {
        let dateformat = bookingEngineData.dateFormat;
        let bookingUrls = [];
        if (inputData.bookingEngineUrls.length > 0) {
            inputData.bookingEngineUrls.filter((i => !i.propertyId.includes(bookingEngineData.propertyId)))
                .map((item => {
                    bookingUrls.push({
                        propertyId: item.propertyId,
                        dateFormat: item.dateFormat,
                        bookingUrl: item.bookingUrl,
                        urlDisabled: item.urlDisabled
                    });
                }));
        }
        bookingUrls.push({ ...bookingEngineData, dateFormat: dateformat })

        let data = {
            ...inputData,
            bookingEngineUrls: bookingUrls
        };

        if (integrationId === undefined) {
            AxiosAPI({
                method: 'post',
                url: `${pAPI_BookingEnginUrlIntegration}`,
                data: data,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        window.location.href = "/app/pages/integration/applications";
                    }, 300);
                }
            });
        } else {
            AxiosAPI({
                method: 'put',
                url: `${pAPI_BookingEnginUrlIntegration}/${integrationId}?group_id=${getGroupID()}`,
                data: data,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            });
        }
    }
    return (
        <Fragment>
            <CardBody>
                <Row className="mb-4">
                    <Colxx xxs="12">
                        <div className="text-center">
                            <h6>{integrationId === undefined ? "Add" : "Update"} Integration</h6>
                            <span className="text-muted">
                                ({selectedProperty[0].name})
                            </span>
                            <Separator className="mb-3" />
                            <Form>
                                <FormGroup className="text-left">
                                    <CustomInput
                                        id="lan"
                                        type="checkbox"
                                        label="Enabled"
                                        checked={!bookingEngineData.urlDisabled}
                                        name="disabled"
                                        onChange={handleCheckChange}
                                    />
                                </FormGroup>
                                <FormGroup className="mb-2 text-left">
                                    <Label>Integration Name</Label>
                                    <Input
                                        type="text"
                                        name="integrationName"
                                        onChange={handleNameChange}
                                        placeholder="Integration Name"
                                        defaultValue={inputData.name}
                                    />
                                </FormGroup>

                                <FormGroup className="mb-2 text-left">
                                    <Label>Booking Url</Label>
                                    <MyTextbox contents={bookingEngineData.bookingUrl}
                                        ref={textbox} onChange={handleChange} />
                                </FormGroup>
                                {isDate && (
                                    <FormGroup className="mb-2 text-left">
                                        <Label>Date Format</Label>
                                        <Input
                                            type="select"
                                            name="dateformat"
                                            onChange={handleDateChange}
                                            value={bookingEngineData.dateFormat}
                                        >
                                            <option value={"YYYY-MM-DD"}>{moment(todayDate).format('YYYY-MM-DD')} (YYYY-MM-DD)</option>
                                            <option value={"DD/MM/YYYY"}>{moment(todayDate).format('DD/MM/YYYY')} (DD/MM/YYYY)</option>
                                            <option value={"MM/DD/YYYY"}>{moment(todayDate).format('MM/DD/YYYY')} (MM/DD/YYYY)</option>
                                            <option value={"DD-MM-YYYY"}>{moment(todayDate).format('DD-MM-YYYY')} (DD-MM-YYYY)</option>
                                            <option value={"MM-DD-YYYY"}>{moment(todayDate).format('MM-DD-YYYY')} (MM-DD-YYYY)</option>
                                            <option value={"MMM D, YYYY"}>{moment(todayDate).format('MMM D, YYYY')} (MMM D, YYYY)</option>
                                        </Input>
                                    </FormGroup>
                                )}
                                <FormGroup className="text-left">
                                    <label>Insert Placeholder</label><br />
                                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                        {tokens.map((token, index) => {
                                            return (
                                                <div key={index} style={{ marginRight: "1.5px" }}>
                                                    <Button
                                                        color={generateRandomColor(index)}
                                                        className="mb-2"
                                                        outline
                                                        size="xs"
                                                        onClick={() => handleInsert(token.value)}
                                                    >{token.value}</Button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </FormGroup>
                                {!isTestIntegration && bookingEngineData.bookingUrl !== "" && (
                                    <FormGroup>
                                        <Button
                                            color="secondary"
                                            size="xs"
                                            onClick={() => handleTestIntegration()}
                                        >Test Integration</Button>
                                    </FormGroup>
                                )}

                                <TestIntegrationBookingUrl
                                    visible={isTestIntegration}
                                    selectedTokens={selectedTokens}
                                    inputData={bookingEngineData}
                                ></TestIntegrationBookingUrl>
                            </Form>

                            <Separator className="mt-4" />
                            <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                {integrationId === undefined ? (
                                    <Button color="primary" size="xs"
                                        onClick={handleSave}
                                    >
                                        Create New Integration
                                    </Button>) : (<Button color="primary" size="xs"
                                        onClick={handleSave}
                                    >
                                        Update Integration
                                    </Button>)}
                                {/* <Button size="xs" color="dark" outline
                                    onClick={() => setIsTestIntegration(!isTestIntegration)}
                                >
                                    Cancel
                                </Button> */}
                            </ButtonGroup>
                        </div>
                    </Colxx>
                </Row>
            </CardBody>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}